import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import {CommonService} from "../common.service";
import {ApiService} from "../api.service";
import {trigger, style, animate, transition, query, keyframes, state, group} from '@angular/animations';
import {ActivatedRoute, Router} from "@angular/router";

declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-case-practice-influence-begin',
    animations: [
        // 页面载入动画效果
        trigger('casePracticeTeamAuthAnimation', [
            transition(':enter', [
                style({opacity: 0}),
                animate('200ms', style({opacity: 1})),
            ])
        ]),
        trigger('noticeAnimation', [
            state('showNotice', style({opacity: 1, transform: 'translate(0%)'})),
            state('hideNotice', style({opacity: 0, transform: 'translate(-200%)'})),
            transition('hideNotice => showNotice', animate('200ms', keyframes([
                style({opacity: 0, transform: 'translate(-150%)'}),
                style({opacity: 0.2, transform: 'translate(-100%)'}),
                style({opacity: 0.4, transform: 'translate(-80%)'}),
                style({opacity: 0.6, transform: 'translate(-60%)'}),
                style({opacity: 0.8, transform: 'translate(-40%)'}),
                style({opacity: 1, transform: 'translate(0%)'}),
            ]))),
            transition('showNotice => hideNotice', animate('200ms', style({opacity: 0})))
        ]),
        trigger('posterAnimation', [
          state('hidePoster', style({opacity: 0, transform: 'scale(0)'})),
          state('showPoster', style({opacity: 1})),
          transition('hidePoster => showPoster', [
            query('#poster', style({opacity: 0}), {optional: true}),
            query('#glass', style({opacity: 0, transform: 'translate(-150%)'}), {optional: true}),
            style({opacity: 1, transform: 'scale(1)'}),
            group([
              query('#poster', animate('2000ms', keyframes([
                style({opacity: 0, transform: 'scale(1) translate(0%)'}),
                style({opacity: 0.35, transform: 'scale(1) translate(0%)'}),
                style({opacity: 0.7, transform: 'scale(1) translate(0%)'}),
                style({opacity: 1, transform: 'scale(1) translate(0%)'}),
                style({opacity: 1,transform: 'scale(1) translate(0%)'}),
                style({opacity: 1,transform: 'scale(1) translate(0%)'}),
                style({opacity: 1,transform: 'scale(1) translate(0%)'}),
                style({opacity: 1,transform: 'scale(1) translate(0%)'}),
                style({opacity: 1,transform: 'scale(1) translate(0%)'}),
                style({opacity: 1,transform: 'scale(1) translate(0%)'}),
                style({opacity: 1,transform: 'scale(1) translate(0%)'}),
                style({opacity: 1,transform: 'scale(1) translate(0%)'}),
                style({opacity: 1,transform: 'scale(1) translate(0%)'}),
                style({opacity: 1,transform: 'scale(1) translate(0%)'}),
                style({opacity: 1,transform: 'scale(1) translate(0%)'}),
                style({opacity: 1,transform: 'scale(0.93) translate(-3%)'}),
                style({opacity: 1,transform: 'scale(0.86) translate(-6.1%)'}),
                style({opacity: 1,transform: 'scale(0.79) translate(-9.3%)'}),
                style({opacity: 1,transform: 'scale(0.71) translate(-13%)'}),
              ])), {optional: true}),
              query('#glass', animate('2000ms', keyframes([
                style({opacity: 1, transform: 'translate(-150%)'}),
                style({opacity: 1, transform: 'translate(-150%)'}),
                style({opacity: 1, transform: 'translate(-150%)'}),
                style({opacity: 1, transform: 'translate(-150%)'}),
                style({opacity: 1, transform: 'translate(-150%)'}),
                style({opacity: 1, transform: 'translate(-150%)'}),
                style({opacity: 1, transform: 'translate(-150%)'}),
                style({opacity: 1, transform: 'translate(-150%)'}),
                style({opacity: 1, transform: 'translate(-150%)'}),
                style({opacity: 1, transform: 'translate(-150%)'}),
                style({opacity: 1, transform: 'translate(-150%)'}),
                style({opacity: 1, transform: 'translate(-150%)'}),
                style({opacity: 1, transform: 'translate(-150%)'}),
                style({opacity: 1, transform: 'translate(-150%)'}),
                style({opacity: 1, transform: 'translate(-120%)'}),
                style({opacity: 1, transform: 'translate(-90%)'}),
                style({opacity: 1, transform: 'translate(-60%)'}),
                style({opacity: 1, transform: 'translate(-30%)'}),
                style({opacity: 1, transform: 'translate(0%)'}),
              ])), {optional: true}),
            ]),
          ]),
          transition('showPoster => hidePoster', animate('200ms', style({opacity: 0, transform: 'scale(1) translate(-150%)'})))
        ]),
        trigger('sideTipAnimation', [
          state('showSideTip', style({opacity: 1,transform: 'translate(0)'})),
          state('hideSideTip', style({opacity: 0,transform: 'translate(-150%)'})),
          transition('hideSideTip => showSideTip', animate('500ms', style({opacity: 1, transform: 'translate(0%)'}))),
          transition('showSideTip => hideSideTip', animate('500ms', style({opacity: 1, transform: 'translate(-150%)'}))),
        ]),
        trigger('cardAnimation', [
          state('showCard', style({opacity: 1, transform: 'scale(1)'})),
          state('hideCard', style({opacity: 0, transform: 'scale(0)'})),
          transition('hideCard => showCard',  animate('300ms', keyframes([
              style({transform: 'matrix3d(0.08700000000000001,-0.09,0.50,0,0.09,0.01,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) scale(0.3)',
                     opacity: 0.8}),
              style({transform: 'matrix3d(0.43065,-0.12,0.50,0,0.12,0.2475,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) scale(0.4)',
                     opacity: 0.9}),
              style({transform: 'matrix3d(0.6525,-0.07,0.50,0,0.07,0.6,0.00,0,-0.5,0,0.87,0,0,0,0.01,1) scale(0.5)',
                     opacity: 0.95}),
              style({transform: 'matrix3d(1,0,0.00,0,0.00,1,0.00,0,0,0,1,0,0,0,0,1) scale(0.55)',
                     opacity: 1}),
              style({transform: 'scale(0.6)', opacity: 1}),
              style({transform: 'scale(0.8)', opacity: 1}),
              style({transform: 'scale(1)', opacity: 1})
            ])
          )),
          transition('showCard => hideCard', animate('300ms', style({opacity: 0, transform: 'translate(0, -200%)'}))),
        ]),
        trigger('dialogueAnimation', [
          state('showDiag', style({opacity: 0.5})),
          state('hideDiag', style({opacity: 0})),
          transition('hideDiag => showDiag', [
            query('#dialogue1', style({opacity: 0}),{optional: true}),
            query('#dialogue2', style({opacity: 0}),{optional: true}),
            query('#dialogue3', style({opacity: 0}),{optional: true}),
            query('#dialogue4', style({opacity: 0}),{optional: true}),
            query('#dialogue5', style({opacity: 0}),{optional: true}),
            query('#dialogue6', style({opacity: 0}),{optional: true}),
            style({opacity: 1}),
            group([
              query('#dialogue1', animate('3500ms', keyframes([
                style({transform: 'translate(0%, 25%)', opacity: 1}),
                style({transform: 'translate(0%, 25%)', opacity: 1}),
                style({transform: 'translate(0%, 25%)', opacity: 1}),
                style({transform: 'translate(0%, 0%)', opacity: 1}),
                style({transform: 'translate(0%, 0%)', opacity: 1}),
                style({transform: 'translate(0%, 0%)', opacity: 1}),
                style({transform: 'translate(0%, 0%)', opacity: 1}),
                style({transform: 'translate(0%, 0%)', opacity: 1}),
                style({transform: 'translate(0%, 0%) scale(0.9)', opacity: 0.9, transformOrigin: '50% 0%'}),
                style({transform: 'translate(0%, 0%) scale(0.8)', opacity: 0.8, transformOrigin: '50% 0%'}),
                style({transform: 'translate(0%, 0%) scale(0.7)', opacity: 0.5, transformOrigin: '50% 0%'}),
                style({transform: 'translate(0%, 0%) scale(0.5)', opacity: 0.3, transformOrigin: '50% 0%'})
              ])), {optional: true}),
              query('#dialogue2', animate('3500ms', keyframes([
                style({opacity: 0}),
                style({transform: 'translate(0%, 50%)', opacity: 0}),
                style({transform: 'translate(0%, 5%)', opacity: 1}),
                style({transform: 'translate(0%, 5%)', opacity: 1}),
                style({transform: 'translate(0%, -40%) scale(0.8)', opacity: 0.8, transformOrigin: '20% 0%'}),
                style({transform: 'translate(0%, -65%) scale(0.5)', opacity: 0.3, transformOrigin: '20% 0%'})
              ])), {optional: true}),
              query('#dialogue3', animate('3500ms', keyframes([
                style({opacity: 0}),
                style({opacity: 0}),
                style({opacity: 0}),
                style({opacity: 0, transformOrigin: '50% 0%'}),
                style({opacity: 1, transform: 'translate(0%, -95%) scale(0.8)', transformOrigin: '50% 0%'}),
                style({opacity: 0.3, transform: 'translate(0%, -175%) scale(0.5)', transformOrigin: '50% 0%'})
              ])), {optional: true}),
              query('#dialogue4', animate('3500ms', keyframes([
                style({opacity: 0}),
                style({opacity: 0}),
                style({opacity: 0}),
                style({opacity: 0, transformOrigin: '0% 0%'}),
                style({opacity: 1, transform: 'translate(0%, -240%) scale(1)', transformOrigin: '0% 0%'}),
                style({opacity: 0.3, transform: 'translate(0%, -320%) scale(0.8)', transformOrigin: '0% 0%'})
              ])), {optional: true}),
              query('#dialogue5', animate('3500ms', keyframes([
                style({opacity: 0}),
                style({opacity: 0}),
                style({opacity: 0}),
                style({opacity: 0}),
                style({opacity: 0}),
                style({opacity: 0}),
                style({opacity: 0}),
                style({opacity: 0}),
                style({opacity: 1, transform: 'translate(0%, -150%) scale(1)', transformOrigin: '50% 0%'}),
                style({opacity: 0.8, transform: 'translate(0%, -230%) scale(0.9)', transformOrigin: '50% 0%'}),
                style({opacity: 0.5, transform: 'translate(0%, -310%) scale(0.8)', transformOrigin: '50% 0%'}),
                style({opacity: 0.3, transform: 'translate(0%, -390%) scale(0.5)', transformOrigin: '50% 0%'})
              ])), {optional: true}),
              query('#dialogue6',  animate('3500ms', keyframes([
                style({opacity: 0}),
                style({opacity: 0}),
                style({opacity: 0}),
                style({opacity: 0}),
                style({opacity: 0}),
                style({opacity: 0}),
                style({opacity: 0}),
                style({opacity: 0}),
                style({opacity: 1, transform: 'translate(0%, -230%) scale(1)', transformOrigin: '0% 0%'}),
                style({opacity: 0.8, transform: 'translate(0%, -310%) scale(0.9)', transformOrigin: '0% 0%'}),
                style({opacity: 0.5, transform: 'translate(0%, -390%) scale(0.8)', transformOrigin: '0% 0%'}),
                style({opacity: 0.3, transform: 'translate(0%, -470%) scale(0.5)', transformOrigin: '0% 0%'})
              ])), {optional: true}),
            ]),
          ]),
          transition('showDiag => hideDiag', style({opacity: 0})),
      ]),
      trigger('problemAnimation', [
          state('showProblem', style({opacity: 1,transform: 'translate(0)'})),
          state('hideProblem', style({opacity: 0,transform: 'translate(-150%)'})),
          transition('showProblem => hideProblem', animate('200ms', style({opacity: 0,transform: 'translate(-150%)'}))),
          transition('hideProblem => showProblem', animate('200ms', style({opacity: 1,transform: 'translate(0)'}))),
      ]),
    ],
  templateUrl: './case-practice-influence-begin.component.html',
  styleUrls: ['./case-practice-influence-begin.component.css',]
})
export class CasePracticeInfluenceBeginComponent implements OnInit, AfterViewInit {
    @Input() exerciseId:number;
    @Input() practiceId:number;
    @Input() practiceMetaId:number;
    @Input() learningPathId:number;
    @Input() practiceList:any;
  //接受传入的参数 用于判断是否为访客
  @Input() userType:string;

    noticeShow: boolean;
    posterShow: boolean;
    sideTipShow: boolean;
    cardShow: boolean;
    problemShow: boolean;
    dialogueShow: boolean;
    step: number;
    clickable: boolean;
    sideTipContent: string;
  assetsRoute: string = "../../assets";

  constructor(
      private commonService:CommonService,
      private apiService: ApiService,
      private route: ActivatedRoute,
      private router: Router
  ) { }

  ngOnInit() {
    this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
      this.noticeShow = false;
      this.clickable = false;
      this.posterShow = false;
      // this.posterStatus = 'initPoster';
      // this.glassStatus = 'initGlass';
      this.sideTipShow = false;
      this.cardShow = false;
      this.sideTipContent = '你被任命为店长...';
      this.problemShow = false;

      let that = this;
      this.apiService.ajax({
          'type':'get',
          'url':'/api/pnoStorePoint/'+this.exerciseId
      }).subscribe(result=>{

        // 如果是访客，永远从头开始
        if(this.userType){
          result.status = 0;
        }
        if(result.status==0){
          this.noticeShow = true;
          setTimeout(function () {
              that.clickable = true;
              that.step = 0;
          },200);
        }else if(result.status==5){
          this.problemShow = true;
          setTimeout(function () {
              that.clickable = true;
              that.step = 3;
          },200);
        }
      });
  }

    screenClick(){
      if(!this.clickable){
        return;
      }

      let _this = this;
      if(this.step == 0){
        this.noticeShow = false;
        this.clickable = false;
        setTimeout(function(){
          _this.posterShow = true;
        }, 200);
        // setTimeout(function () {
        //     _this.posterStatus = 'showPoster';
        // },500);
        // setTimeout(function () {
        //     _this.posterStatus = 'smallPoster';
        //     _this.glassStatus = 'showGlass';
        // },1500);
        setTimeout(function () {
          _this.step = 1;
          _this.clickable = true;
        },2500);
      }else if(this.step == 1){
        this.clickable = false;
        this.posterShow = false;
        setTimeout(function () {
          _this.sideTipShow = true;
        },600);
        setTimeout(function () {
          _this.cardShow = true;
        },900);
        setTimeout(function () {
          _this.step = 2;
          _this.clickable = true;
        },1700);
      }else if(this.step==2){
        this.clickable = false;
        this.cardShow = false;
        this.sideTipShow = false;
        setTimeout(function () {
          _this.sideTipContent = '没想到，实体店开张后，问题越来越多';
          _this.sideTipShow = true;
          _this.dialogueShow = true;
        },500);
        setTimeout(function () {
          _this.sideTipShow = false;
          _this.dialogueShow = false;
        },4000);
        setTimeout(function () {
          _this.apiService.ajax({
            'type':'post',
            'url':'/api/pnoStorePoint/'+_this.exerciseId,
            'data':{
                'pno_store_point_id':5
            }
          }).subscribe(result=>{
            _this.problemShow = true;
          });
        },4200);
      }
    }

    ngAfterViewInit(){
        this.commonService.initPage({
            'backgroundColor':'white'
        });
    }

    goToMain(){
        this.apiService.ajax({
            'type':'post',
            'url':'/api/pnoStorePoint/'+this.exerciseId,
            'data':{
                'pno_store_point_id':10
            }
        }).subscribe(result=>{
            let link=['case-practice-influence-main',this.learningPathId,this.practiceId,this.exerciseId];
            let type = null
            this.route.queryParams.subscribe(queryParams=>{
                type = queryParams['type']
            })
            if(type){
              this.router.navigate(link,{queryParams:{type:'huatek'}});
            }else{
              this.router.navigate(link);
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/case-practice-influence-begin/case-practice-influence-begin.component.ts